import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { SqGameBackEndModel } from 'types/SqGame.types';

export const gameToDoc = (game: SqGameBackEndModel): DocumentData => {
  return {
    sqGameId: game.sqGameId,
    matchId: game.matchId ?? '',
    title: game.title,
    description: game.description,
    url: game.url,
    homeTeam: game.homeTeam,
    awayTeam: game.awayTeam,
    gameProgress: game.gameProgress,
    gameState: game.gameState,
    startingDate: game.startingDate,
    boardLocked: game.boardLocked,
    gameAdmin: game.gameAdmin,
    playerIds: game.playerIds,
    openSquares: game.openSquares,
    pickingPlayer: game.pickingPlayer,
    lastPickingPlayer: game.lastPickingPlayer,
    quarterScores: game.quarterScores,
    quarterWinners: game.quarterWinners,
    date: game.date,
    bannedPlayerIds: game.bannedPlayerIds,
    maxPicksPerPlayer: game.maxPicksPerPlayer,
    createdBy: game.createdBy,
    createdOn: Date.now(),
  };
};

export const gameConverter: FirestoreDataConverter<SqGameBackEndModel> = {
  toFirestore(game: SqGameBackEndModel): DocumentData {
    // return { ...gameToDoc(game), ...getModifiedInfo() };
    return gameToDoc(game);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): SqGameBackEndModel {
    const game = docSnap.data(options);

    return {
      sqGameId: game.sqGameId,
      matchId: game.matchId ?? '',
      title: game.title,
      description: game.description,
      url: game.url,
      homeTeam: game.homeTeam,
      awayTeam: game.awayTeam,
      gameProgress: game.gameProgress,
      gameState: game.gameState,
      gameAdmin: game.gameAdmin,
      playerIds: game.playerIds,
      openSquares: game.openSquares,
      pickingPlayer: game.pickingPlayer,
      lastPickingPlayer: game.lastPickingPlayer,
      date: game.date,
      startingDate: game.startingDate,
      boardLocked: game.boardLocked,
      quarterScores: game.quarterScores,
      quarterWinners: game.quarterWinners,
      bannedPlayerIds: game.bannedPlayerIds || [],
      maxPicksPerPlayer: game.maxPicksPerPlayer ?? 0,
      createdBy: game.createdBy,
      createdOn: game.createdOn,
    };
  },
};
